<template>
  <div class="llenarEncuentro">
    <div
      v-bind:style="[ !banderaAbrirHistoriaClinica? {width:'100%', height: '100%'} : {display:'flex',justifyContent: 'space-around', height: '100% '}]"
    >
      <div
        v-if="getVariablesFormularios.length!=0"
        v-bind:style="[ !banderaAbrirHistoriaClinica? {width:'100%'} : {width:'65%' }]"
        style="height: 100%; width:65%; transition: .3s; position: relative;"
      >
        <div class="contenedorBotonVolver">
          <button
            @click="formularioActualizadoCorrectamente"
            class="botonCircularPequeno elevation-2"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </button>
          <!-- <div>
            <span v-show="getVariablesFormularios.length!=0" id="TituloConsultaFormulario">{{getNombreFormulario}}</span>
          </div>-->
        </div>
        <div>
          <tarjetas-nuevas-momento
            @formularioActualizado="formularioActualizadoCorrectamente"
            :banderaFormularioSerie="banderaFormularioSerie"
            :texto_introductorio="texto_introductorio"
          ></tarjetas-nuevas-momento>
        </div>
      </div>
      <div v-else id="DivListarCategorias">
        <listado-categorias
          :formulariosMomentosllenos="formulariosMomentosllenos"
          :banderaOcultarMas="banderaOcultarMas"
          :formulariosLlenosTipoMomento="formulariosLlenosTipoMomento"
        ></listado-categorias>
      </div>
    </div>
    <SubirArchivo
      :visualizar="false"
      :verArchivos="false"
      :paciente="paciente"
      :id="$store.getters.getId"
      :nombreDocumento="$store.getters.getEncuentro"
      :coleccion="$store.getters.getEscogerEvento"
    />
  </div>
</template>

<script>
import axios from "../apiService/config/axios.js";
import { serverBus } from "../main";
// import datePicker from "vue-bootstrap-datetimepicker";
import metodos_comunes from "../js/metodos_comunes";
import Vue from "vue";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import { consultarFormulariosExistentes } from "../apiService/request/CrudFormulario.js";
import TarjetasFormulario from "../components/Formulario/TarjetasFormulario";
import TarjetasFormulariosMomentos from "../components/TarjetasFormulariosMomentos/TarjetasFormulariosMomentos";
import ListadoCategorias from "../components/ListadoCategorias/ListadoCategorias";
import { consultarFormulariosMomentosLlenos } from "../apiService/request/CrudEncuentro.js";
import { crearFormulario } from "../apiService/request/CrudFormulario.js";
import TarjetasNuevasMomento from "../components/TarjetasNuevasMomento/TrajetasNuevasMomento";
import { consultarEstructuraFormulario, consultarEstructuraCuestionarioPorId } from "../apiService/request/CrudSeguimiento.js";
import { actualizarFormulario } from "../apiService/request/CrudFormulario.js";
import { formulariosLlenosPorTipoMomento } from "../apiService/request/CrudEncuentro.js";
import DatosInicioSeguimiento from "../components/DatosInicioSeguimiento/DatosInicioSeguimiento";
import Marcaciones from "../components/Marcaciones/Marcaciones";
import Icono from "../components/Icono/Icono";
import SubirArchivo from "../components/SubirArchivo/SubirArchivo";
import { prerrequisitos } from "../apiService/request/CrudEncuentro.js";

Vue.use(VueMaterial);
export default {
  data() {
    return {
      banderaFormularioSerie: false,
      nombre_formulario: "",
      config: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        locale: "es"
      },
      variablesActualizadas: [],
      filtro_busqueda: [],
      banderaAbrirHistoriaClinica: false,
      banderaNombreLargo: false,
      gridTemplate: "1fr 1fr 1fr",
      gridTemplate2: "1fr 1fr 1fr",
      padding: "2% 3% 2% 3%",
      variablesObligatorias: [],
      formulariosMomentosllenos: [],
      variablesFormularioNuevo: [],
      formulariosLlenosTipoMomento: [],
      banderaOcultarMas: false,
      iconoHC:
        "M29,5h-6V4c0-0.6-0.4-1-1-1h-2.1c-0.4-1.7-2-3-3.9-3s-3.4,1.3-3.9,3H10C9.4,3,9,3.4,9,4v1H3C1.3,5,0,6.3,0,8v33c0,1.7,1.3,3,3,3h26c1.7,0,3-1.3,3-3V8C32,6.3,30.7,5,29,5z M26,11v27H6V11H26z M11,5h2c0.6,0,1-0.4,1-1c0-1.1,0.9-2,2-2s2,0.9,2,2c0,0.6,0.4,1,1,1h2v4H11V5z M30,41c0,0.6-0.5,1-1,1H3c-0.6,0-1-0.5-1-1V8c0-0.6,0.5-1,1-1h6v2H5c-0.6,0-1,0.4-1,1v29c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V10c0-0.6-0.4-1-1-1h-4V7h6c0.6,0,1,0.5,1,1V41z M9,27.3h3.7V31c0,0.6,0.4,1,1,1h4.7c0.6,0,1-0.4,1-1v-3.7H23c0.6,0,1-0.4,1-1v-4.7c0-0.6-0.4-1-1-1h-3.7V17c0-0.6-0.4-1-1-1h-4.7c-0.6,0-1,0.4-1,1v3.7H9c-0.6,0-1,0.4-1,1v4.7C8,26.9,8.4,27.3,9,27.3z M10,22.7h3.7c0.6,0,1-0.4,1-1V18h2.7v3.7c0,0.6,0.4,1,1,1H22v2.7h-3.7c-0.6,0-1,0.4-1,1V30h-2.7v-3.7c0-0.6-0.4-1-1-1H10V22.7z",
      fileSelected: null,
      iconoCargar:
        "M35.9,18.2C35,11.3,29,6,22,6c-5.6,0-10.5,3.3-12.8,8.3C3.8,15.6,0,20.4,0,26c0,6.6,5.4,12,12,12h22c5.5,0,10-4.5,10-10C44,23.1,40.6,19.1,35.9,18.2z M34,36H12C6.5,36,2,31.5,2,26c0-4.8,3.4-8.9,8.1-9.8l0.5-0.1l0.2-0.5C12.7,11,17.1,8,22,8c6.3,0,11.5,4.9,12,11.1L34,20l0.8,0.1c4.1,0.4,7.2,3.8,7.2,8C42,32.4,38.4,36,34,36z M28.7,21.3c0.4,0.4,0.4,1,0,1.4C28.5,22.9,28.3,23,28,23s-0.5-0.1-0.7-0.3L23,18.4V31c0,0.6-0.4,1-1,1s-1-0.4-1-1V18.4l-4.3,4.3C16.5,22.9,16.3,23,16,23s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6-6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2L28.7,21.3zM0,0h44 M44,44H0",
      loading: false,
      paciente: {}
    };
  },
  mounted() {
    this.$root.$on('formularioSerie', (data) => {
      this.banderaFormularioSerie = data;
    });
    this.paciente = {
      documento: this.$store.getters.getCedulaPaciente,
      nombre: this.$store.getters.getNombrePaciente
    };

    serverBus.$on("crearFormularioNuevo", () => {
      this.crearFormularioNuevo();
    });
    serverBus.$on("formularioActualizadoExitosamente", respuesta => {
      // this.consultarInformacionFormularios(
      //   this.getCedulaPaciente,
      //   this.$store.getters.getNombreFormulario
      // );
    });
    serverBus.$on("verCategoriaFormulario", (nombreCategoria,coleccion) => {
      this.$store.dispatch("setColeccion", coleccion);
      this.formulariosLlenosTipoMomento = [];
      this.consultarFormulariosLlenosPorTipoMomento(nombreCategoria);
    });
    serverBus.$on(
      "abrirTarjetaFormulario",
      (id_formulario, nombreCategoria) => {
        this.$store.dispatch("setIdFormulario", id_formulario);
        this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
        this.$store.dispatch("setNombreFormulario", nombreCategoria);
        // this.consultarEstructuraFormularios(
        //   this.$store.getters.getIdFormulario
        // );
      }
    );
    serverBus.$on("formularioActualizadoExitosamenteMomento", respuesta => {
      const momento = "momento" + this.$store.getters.getMomentoActual;
      // this.variablesFormularioNuevo=[]
      if (!this.$store.getters.getBanderaBotonMas) {
        // this.$store.dispatch("setMensajeChatBox", "Terminar");
      }
      this.$store.dispatch("setIdFormulario", null);
      this.$store.dispatch("setNombreFormulario", null);
      this.$store.dispatch("setVariablesFormularios", []);
      this.consultarFormulariosMomentos(momento);
    });
  },
  created() {},
  beforeDestroy() {
    serverBus.$off("formularioActualizadoExitosamente");
    serverBus.$off("verCategoriaFormulario");
    serverBus.$off("formularioActualizadoExitosamenteMomento");
    serverBus.$off("crearFormularioNuevo");
    serverBus.$off("abrirTarjetaFormulario");
    this.$store.dispatch("setEsquemaFormularioSerie", []);
  },
  beforeUpdate() {},
  computed: {
    getMomentoActual() {
      if (this.$store.getters.getMomentoActual != null) {
        this.funcionPrerrequisitos();
      }
      return this.$store.getters.getMomentoActual;
    },
    getCancelarFormulario() {
      if (this.$store.getters.getCancelarFormulario != null) {
        this.variablesActualizadas = [];
        this.$store.dispatch("setVariablesActualizadas", []);
        this.$store.dispatch("setCancelarFormulario", null);
      }
      return this.$store.getters.getCancelarFormulario;
    },
    getNombreFormulario() {
      if (this.$store.getters.getNombreFormulario != null) {
      }
      return this.$store.getters.getNombreFormulario;
    },
    cambiaPanelLateral() {
      if (
        this.$store.getters.cambiaPanelLateral == "5" &&
        this.$store.getters.getNombreFormulario != null
      ) {
        // this.consultarInformacionFormularios(
        //   this.getCedulaPaciente,
        //   this.$store.getters.getNombreFormulario
        // );
      }
      return this.$store.getters.cambiaPanelLateral;
    },
    getCedulaPaciente() {
      return this.$store.getters.getCedulaPaciente;
    },
    getNombreCampo() {
      if (
        this.$store.getters.getNombreCampo != null &&
        this.$store.getters.getNombreCampo == "fin"
      ) {
        // self.$store.dispatch('setNombreCampo', null)
        this.banderaAbrirHistoriaClinica = false;
        let self = this;
        setTimeout(function() {
          self.resetearPanelAuxiliar();
          self.$store.dispatch("setVariablesFormularios", []);
          self.$store.dispatch("setVariablesActualizadas", []);
          // self.$store.dispatch('setNumeroCampo', null)
          self.$store.dispatch("setNombreFormulario", null);
          self.$store.dispatch("setCampoIngresado", null);
          self.$store.dispatch("setNombreCampo", null);
          // self.consultarFormulariosMomentos(
          //   "momento" + self.$store.getters.getMomentoActual
          // );
        }, 1500);
      }
      return this.$store.getters.getNombreCampo;
    },
    getVariablesFormularios() {
      if (this.$store.getters.getVariablesFormularios != null) {
        this.variablesObligatorias = this.$store.getters.getVariablesFormularios.filter(
          variable => variable.obligatorio === true
        );
        this.variablesObligatorias = this.variablesObligatorias.map(
          variable => variable.nombre
        );
      }
      return this.$store.getters.getVariablesFormularios;
    },
    getFormulariosExistentes() {
      return this.$store.getters.getFormulariosExistentes;
    },
    getBanderaFormularioExistenteAbierto() {
      if (this.$store.getters.getBanderaFormularioExistenteAbierto == true) {
        this.gridTemplate2 = "1fr";
      }
      return this.$store.getters.getBanderaFormularioExistenteAbierto;
    }
  },
  watch: {
    getNombreCampo() {},
    getNombreFormulario() {},
    getCampoIngresado() {},
    getCedulaPaciente() {},
    cambiaPanelLateral() {},
    getIdFormulario() {},
    getCancelarFormulario() {},
    getBanderaFormularioExistenteAbierto() {},
    getMomentoActual() {},
    getVariablesFormularios() {}
  },
  components: {
    // datePicker,
    TarjetasFormulario,
    TarjetasFormulariosMomentos,
    TarjetasNuevasMomento,
    ListadoCategorias,
    Marcaciones,
    DatosInicioSeguimiento,
    Icono,
    SubirArchivo
  },
  props: {
    texto_introductorio: {
      type: String,
      default: null
    },
  },
  methods: {
    formularioActualizadoCorrectamente() {
      console.log(
        "si entre despues de actualizacion",
        this.$store.getters.getEscogerEvento
      );
      if (this.$store.getters.getEscogerEvento == "encuentros") {
        console.log(
          "si entre despues de actualizacion2",
          this.$store.getters.getEscogerEvento
        );
        this.consultarFormulariosMomentos();
      }
      this.$store.dispatch("setEsquemaFormularioSerie", []);
      this.banderaFormularioSerie = false;
    },
    async consultarFormulariosLlenosPorTipoMomento(nombre_form) {
      try {
        if (!this.$store.getters.getCargando) {
          this.$store.dispatch("setCargando", true);
        }
        const respuesta = await formulariosLlenosPorTipoMomento(
          this.$store.getters.getId,
          "momento" + this.$store.getters.getMomentoActual,
          nombre_form
        );
        this.formulariosLlenosTipoMomento = respuesta.data.data;
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async crearFormularioNuevo() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await crearFormulario(
          this.$store.getters.getColeccion,
          this.getNombreFormulario,
          this.$store.state.provider_email,
          "momento" + this.$store.getters.getMomentoActual,
          parseInt(this.$store.getters.getCedulaPaciente),
          this.$store.getters.getEncuentro ? 'encuentros' : 'formularios',
          this.$store.getters.getId
        );
        // this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
        this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
        this.$store.dispatch("setIdFormulario", respuesta.data.data.docId);
        // await this.consultarEstructuraFormularios(
        //   this.$store.getters.getIdFormulario
        // );
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async funcionPrerrequisitos() {
      try{
        const respuestaPrerrequisitos = await prerrequisitos("encuentros", Number(this.$store.getters.getCedulaPaciente),
        this.$store.state.provider_email, this.$store.getters.getId);        
      }
      finally {
        this.consultarFormulariosMomentos();
      }
    },
    async consultarFormulariosMomentos() {
      const respuesta = await consultarFormulariosMomentosLlenos(
        this.$store.getters.getId,
        "momento" + this.$store.getters.getMomentoActual
      );
      this.formulariosMomentosllenos = respuesta.data.data;
      this.$store.dispatch("setBanderaFormularioExistenteAbierto", false);
      this.$store.dispatch("setestadoPanel", "5");
      this.$store.dispatch("setVariablesFormularios", []);
      // this.variablesFormularioNuevo=[]
    },
    async consultarInformacionFormularios(documento, nombre_formulario) {
      const respuesta = await consultarFormulariosExistentes(
        documento,
        nombre_formulario
      );
      this.$store.dispatch("setFormulariosExistentes", respuesta.data);
      this.filtro_busqueda = [];
      if (this.$store.getters.getFormulariosExistentes.data.length > 0) {
        this.filtro_busqueda.push(
          this.$store.getters.getFormulariosExistentes.data[0].nombre_formulario
        );
      }
    },
    // async consultarEstructuraFormularios(IdFormulario) {
    //   if (
    //     this.$store.getters.getIdFormulario != null &&
    //     this.$store.getters.getIdFormulario != ""
    //   ) {
    //     console.log('iden panel',this.$store.getters.getIdFormulario);
        
    //     this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
        
        // const respuesta = await consultarEstructuraCuestionarioPorId(IdFormulario, this.$store.getters.getColeccion, this.getNombreFormulario);
        // this.$store.dispatch(
        //   "setVariablesFormularios",
        //   respuesta.data.data.variables
      //   );
      //   this.$store.dispatch("setNombreFormulario", respuesta.data.data.key);
      //   this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
      //   if (
      //     respuesta &&
      //     respuesta.data &&
      //     respuesta.data.data &&
      //     respuesta.data.data.formularioSerie
      //   ) {
      //     this.$store.dispatch("setSerieFormularios", []);
      //     this.$store.dispatch(
      //       "setEsquemaFormularioSerie",
      //       JSON.parse(
      //         JSON.stringify({
      //           variables: respuesta.data.data.variables
      //         })
      //       )
      //     );
      //     this.banderaFormularioSerie = true;
      //   }
      // }
    // },
    verificarValorIngresado: function(valor, caracVariable) {
      let mensaje_no_valido = "";
      let verificacion = true;
      if (caracVariable.obligatorio === true && valor === "") {
        // mensaje_no_valido = constantesFor.MEN_FOR_ERROR_OBLIGATORIO;
        verificacion = false;
        return {
          verificacion,
          mensaje_error: "mensaje_no_valido1",
          puntaje: 0
        };
      }
      if (
        caracVariable.limites == true &&
        (valor < caracVariable.lim_inferior ||
          valor > caracVariable.lim_superior)
      ) {
        // mensaje_no_valido = constantesFor.MEN_FOR_ERROR_LIMITES;
        verificacion = false;
        return {
          verificacion,
          mensaje_error: "mensaje_no_valido2",
          puntaje: 0
        };
      }
      return { verificacion, mensaje_error: "mensaje_no_valido", puntaje: 0 };
    },
    eliminarChip: function() {
      this.filtro_busqueda = [];
    },
    calcularLongitudLabel: function() {},
    cerrarHistoriaClinica: function() {
      this.banderaAbrirHistoriaClinica = false;
    },
    AbrirHistoriaClinica: function() {
      this.banderaAbrirHistoriaClinica = true;
      this.gridTemplate = "1fr 1fr";
    },
    cambiarEstadoModal(estado) {
      this.$store.dispatch("cambiarEstadoModal", estado);
    },
    cambiarMensajeModal(mensaje) {
      this.$store.dispatch("cambiarMensajeModal", mensaje);
    },
    cambiarIconoModal(src) {
      this.$store.dispatch("cambiarIconoModal", src);
    },
    actualizarFormularioActualPanel: function() {
      // this.$store.dispatch("setMensajeChatBox", "Terminar");
    },
    actualizarCampo(index5, nombreCampo, tipo) {
      let variablesFormularios = this.$store.getters.getVariablesFormularios;
      this.variablesActualizadas = this.$store.getters.getVariablesActualizadas;
      variablesFormularios[index5].valor = document.getElementById(
        variablesFormularios[index5].nombre
      ).value;
      let banderaReemplazarValor = false;
      const verificacion = this.verificarValorIngresado(
        document.getElementById(variablesFormularios[index5].nombre).value,
        variablesFormularios[index5]
      );
      if (verificacion.verificacion === true) {
        this.variablesActualizadas.map(function(elemento) {
          if (elemento.nombre == "variable" + (index5 + 1)) {
            elemento.valor = parseInt(
              elemento.valor
                .toString()
                .replace(
                  elemento.valor.toString(),
                  document
                    .getElementById(variablesFormularios[index5].nombre)
                    .value.toString()
                )
            );
            banderaReemplazarValor = true;
          }
        });
        if (banderaReemplazarValor == false) {
          if (tipo == "numero") {
            this.variablesActualizadas.push({
              nombre: "variable" + (index5 + 1),
              valor: parseInt(
                document.getElementById(variablesFormularios[index5].nombre)
                  .value
              ),
              nombre_campo: metodos_comunes.reemplazarCaracteresEspeciales(
                nombreCampo
              )
            });
          } else {
            this.variablesActualizadas.push({
              nombre: "variable" + (index5 + 1),
              valor: document.getElementById(
                variablesFormularios[index5].nombre
              ).value,
              nombre_campo: metodos_comunes.reemplazarCaracteresEspeciales(
                nombreCampo
              )
            });
          }
        }
        this.$store.dispatch(
          "setVariablesActualizadas",
          this.variablesActualizadas
        );
        this.$store.dispatch("setVariablesFormularios", []);
        this.$store.dispatch("setVariablesFormularios", variablesFormularios);
      } else {
        this.cambiarEstadoModal(true);
        this.cambiarMensajeModal("Valor ingresado no valido");
        this.cambiarIconoModal("../assets/check2.png");
        document.getElementById(
          variablesFormularios[index5].nombre
        ).value = null;
      }
      this.$store.dispatch(
        "setVariablesActualizadas",
        this.variablesActualizadas
      );
      this.$store.dispatch("setVariablesFormularios", []);
      this.$store.dispatch("setVariablesFormularios", variablesFormularios);
    },
    actualizarCampoDate(index5, nombreCampo) {
      let self = this;
      setTimeout(function() {
        let variablesFormularios = self.$store.getters.getVariablesFormularios;
        if (
          document
            .getElementById(variablesFormularios[index5].nombre)
            .getElementsByTagName("input")[0].value
        ) {
          let nuevaFecha =
            Date.parse(
              document
                .getElementById(variablesFormularios[index5].nombre)
                .getElementsByTagName("input")[0].value
            ) + 57600000;
          variablesFormularios[index5].valor = nuevaFecha;
          self.variablesActualizadas =
            self.$store.getters.getVariablesActualizadas;
          if (nuevaFecha !== null) {
            self.variablesActualizadas.push({
              nombre: "variable" + (index5 + 1),
              valor: nuevaFecha,
              nombre_campo: metodos_comunes.reemplazarCaracteresEspeciales(
                nombreCampo
              )
            });
            self.$store.dispatch(
              "setVariablesActualizadas",
              self.variablesActualizadas
            );
            self.$store.dispatch("setVariablesFormularios", []);
            self.$store.dispatch(
              "setVariablesFormularios",
              variablesFormularios
            );
          }
        }
      }, 100);
    },
    actualizarCampoLista(index5, nombreCampo, value) {
      if (value != null) {
        let variablesFormularios = this.$store.getters.getVariablesFormularios;
        variablesFormularios[index5].valor = value;
        let banderaReemplazarValor = false;
        this.variablesActualizadas = this.$store.getters.getVariablesActualizadas;
        this.variablesActualizadas.map(function(elemento) {
          if (elemento.nombre == "variable" + (index5 + 1)) {
            elemento.valor = elemento.valor.replace(elemento.valor, value);
            banderaReemplazarValor = true;
          }
        });
        if (banderaReemplazarValor == false) {
          this.variablesActualizadas.push({
            nombre: "variable" + (index5 + 1),
            valor: value,
            nombre_campo: metodos_comunes.reemplazarCaracteresEspeciales(
              nombreCampo
            )
          });
        }
        this.$store.dispatch(
          "setVariablesActualizadas",
          this.variablesActualizadas
        );
        this.$store.dispatch("setVariablesFormularios", []);
        this.$store.dispatch("setVariablesFormularios", variablesFormularios);
      }
    },
    /**Este metodo se crean las tarjetas de los elementos presentes en los formularios. Cada elemento posee variables que deben recorrerse
     * para mostrar los datos correspondientes( siempre y cuando esas variables sean visibles)
     */
    resetearPanelAuxiliar: function() {
      (this.nombre_formulario = ""), (this.matriz_campos_tarjetas = []);
    },
    filtroVariablesObligatoriasDiligenciadas: function() {
      const self = this;
      const variablesActualizadas = this.$store.getters
        .getVariablesActualizadas;
      const variablesDiligenciadas = this.variablesObligatorias.map(z => {
        return variablesActualizadas.filter(
          c =>
            c.nombre_campo == metodos_comunes.reemplazarCaracteresEspeciales(z)
        );
      });
      this.filtroVariablesObligatoriasSinDiligenciar(variablesDiligenciadas);
    },
    filtroVariablesObligatoriasSinDiligenciar: function(
      variablesDiligenciadas
    ) {
      const self = this;
      variablesDiligenciadas = variablesDiligenciadas.filter(c => c.length > 0);
      variablesDiligenciadas = variablesDiligenciadas.map(
        c => c[0].nombre_campo
      );
      const variablesObligatoriasSinDiligenciar = this.variablesObligatorias.filter(
        function(x) {
          return (
            variablesDiligenciadas.indexOf(
              metodos_comunes.reemplazarCaracteresEspeciales(x)
            ) < 0
          );
        }
      );
      this.validacionActualizarFormulario(variablesObligatoriasSinDiligenciar);
    },
    validacionActualizarFormulario: function(
      variablesObligatoriasSinDiligenciar
    ) {
      if (variablesObligatoriasSinDiligenciar.length === 0) {
        this.actualizarFormularioActualPanel();
        this.actualizarFormularioActual();
      } else {
        this.cambiarEstadoModal(true);
        this.cambiarMensajeModal(
          "Los siguientes campos son obligatorios: " +
            variablesObligatoriasSinDiligenciar
        );
        this.cambiarIconoModal("../assets/check2.png");
      }
    },
    async actualizarFormularioActual() {
      const respuesta = await actualizarFormulario(
        this.$store.getters.getIdFormulario,
        this.$store.getters.getVariablesActualizadas,
        "formularios", 
        this.$store.state.provider_email
      );
      this.$store.dispatch("setVariablesActualizadas", []);
      this.$store.dispatch("setIdFormulario", null);
      this.cambiarEstadoModal(true);
      this.cambiarMensajeModal("Formulario actualizado correctamente");
    }
  }
};
</script>
<style scoped>
.contenedorBotonVolver {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: -42px;
  left: -6px;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  position: sticky;
  padding: 5%;
}
#DivListarCategorias {
  position: sticky;
  /* padding: 5%; */
}
#BotonCerrarHistoriaClinica {
  background: white;
  border: none;
  width: 6%;
  height: 100%;
  margin-top: 5%;
  padding: 0%;
}
#FormulariosExistentes {
  height: 100%;
  transition: width 0.7s ease;

  position: sticky;
}

#md-button1 {
  /* border: 1px solid #ccc; */
  border: none;
  font-family: "Nunito", sans-serif;
  font-size: 0.8vw;
  /* color: #666666 !important; */
  font-weight: bold;
  width: 10%;
}
.md-field.md-theme-default.md-has-value .md-input {
  font-family: "Nunito", sans-serif;
  color: #999999;
}
.md-field {
  font-family: "Nunito", sans-serif;
  color: #999999;
}
ul li {
  font-family: "Nunito", sans-serif;
  color: #999999;
}
::placeholder {
  font-size: 0.8vw;
  font-family: "Nunito", sans-serif;
}

#MensajeModal {
  font-size: 1.2vw;
  font-family: "Nunito", sans-serif;
  color: #999999;
  margin-left: 4%;
}
.contenedor-modal {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
}
.contenedor-modal button {
  position: relative;
  top: 40%;
}
#DivVerMas {
  display: flex;
  justify-content: space-between;
  width: 10%;
}
#DivBotonGuardar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
#DivInformacionResumen {
  position: relative;
  min-width: 30% !important;
  margin: 0%;
  height: auto;
  padding: 3%;
  /* padding-right: 3%; */
  /* display: block !important; */
  /* display: flex;
        justify-content: space-between; */
}
#NombreCampotarjetaResumen {
  font-weight: bolder;
  color: #999999;
  width: 50%;
  margin: 3% 0px 2% 0px;
  text-align: left;
  font-size: 1.1vw;
  font-family: "Nunito", sans-serif;
}

#ValorCampotarjetaResumen {
  font-family: "Nunito", sans-serif;
  font-size: 1.1vw;
  color: #999;
  margin: 3% 0px 2% 5%;
  width: 50%;
}
#NombreCampoFormulario {
  font-weight: bolder;
  color: #999999;
  width: 50%;
  margin: 1% 0px 1% 0px;
  text-align: left;
  font-size: 1.05vw;
}
#Linea {
  border: 0.7px solid #ccc;
  margin: 2px;
  width: 70%;
  margin: 1% auto 0px auto;
}
#Linea2 {
  border: 0.5px solid #ccc;
  width: 100%;
  margin: 0px;
}
input:focus {
  outline: 0;
}
button:focus {
  outline: 0;
}
textarea:focus {
  outline: 0;
}
#TituloConsultaFormulario {
  font-family: "Nunito", sans-serif;
  font-size: 1.3vw;
  /* width: 80%; */
  width: 100%;
  color: #999;
  text-align: start;
  /* padding: 5% 0% 0% 10%;  */
  /* margin: auto; */
  margin: 5% 0% 0% 10%;
}
#BotonRegresar {
  border: none;
  background: white;
  margin-top: 3%;
}
#DivRegresar {
  display: flex;
  justify-content: start;
  width: 75%;
  margin: auto;
  margin-top: 3%;
}
#tarjetaResumen {
  margin: 3% auto 0% auto;
  width: 90%;
  height: auto;
  padding: 0% 4% 3% 4%;

  position: static;
}
#DivBotonesFormulario {
  justify-content: center;
  margin: 5% auto 5% auto;
  width: 70%;
  border: 1.1px solid #ccc;
  border-radius: 7px;
  padding: 2%;
  box-shadow: -1px 2px 2px #ccc;
}
#DivBotonFormulario {
  padding: 2%;
  margin: auto;
  display: flex;
  justify-content: flex-start;
}
#BotonFormulario {
  width: 80%;
  border: none;
  padding: 2%;
  font-family: "Nunito", sans-serif;
  font-size: 1.5vw;
  color: #999;
  text-align: start;
  background: white;
}
#BotonInformaciónEvento {
  border: none;
  background: white;
  padding: 0px;
  font-family: "Nunito", sans-serif;
  color: #999;
  margin: auto;
  width: 100%;
  height: 100%;
  text-align: start;
}
#DivBotonInformaciónEvento {
  padding: 2%;
  margin: auto;
  height: 20%;
}
#NombreTarjeta {
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
}
#InformacionTarjeta {
  font-family: "Nunito", sans-serif;
  color: #999;
  margin: 3% 0px 1% 0%;
  display: flex;
  justify-content: space-between;
}
#InformacionTarjeta2 {
  font-family: "Nunito", sans-serif;
  color: #999;
  /* margin: 3% 0px 1% 5%;    */
  display: flex;
  justify-content: space-between;
}
input[type="text"] {
  width: 45%;
  margin-left: 5%;
  font-family: "Nunito", sans-serif;
  font-size: 0.9vw;
  color: rgb(153, 153, 153);
}
input[type="number"] {
  width: 45%;
  font-size: 0.9vw;
  color: rgb(153, 153, 153);
  border-radius: 4px;
}
input[type="date"] {
  width: 45%;
  border: none;
  margin-left: 5%;
  font-size: 0.9vw;
  color: rgb(153, 153, 153);
}

#BotonGuardar {
  border: none;
  background: white;
  font-family: "Nunito", sans-serif;
  font-size: 0.8vw;
  font-weight: bold;
  color: #666;
  margin-top: 5%;
}
#BotonVerMas {
  border: none;
  background: white;
  font-family: "Nunito", sans-serif;
  color: #999;
  margin-top: 1%;
}

.row {
  display: flex;
  justify-content: space-between;
  border: 1.1px solid #ccc;
  border-radius: 8px;
  margin: 5% auto 1% auto;
  width: 80%;
}
.bordeTarjeta {
  width: 6%;
  background: #e4eaea;
  border: 0.1px solid #e4eaea;
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
}
.rowInformacion {
  padding: 3% 2% 2% 5%;
  width: 94%;
}
#NombreTarjeta {
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
}
.textarea {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 1.8vw;
  margin-left: 4%;
  font-family: "Nunito", sans-serif;
  font-size: 1vw;
  color: #666;
  margin: 0px;
  text-align: start;
  font-weight: bold;
  resize: none;
  /* margin: 0px 0px 0px 2%; */
  border: none;
  /* border: none; */
  -ms-grid-rows: 1;
  resize: vertical;
}
#FechaCreacion {
  margin: 1%;
  font-size: 0.7vw;
  font-family: "Nunito", sans-serif;
  color: #999999;
  display: flex;
  text-align: center;
  vertical-align: middle;
}
</style>
<style lang="scss">
// @import "../assets/sass/abstracts/variables";
// @import "../assets/sass/componentes/botones";
@import "../assets/sass/main";

.contenedorBotones {
  display: flex;
  justify-content: space-between;
  // width: 12.5vw;
  position: fixed;
  right: 1.667vw;
  bottom: 1.667vw;
  z-index: 150;
  .btn-file {
    @extend %iconoBordeado;
    cursor: pointer;
    box-shadow: none;
    height: 3.75vw !important;
    width: 3.75vw !important;
    border-color: $gris !important;
    background-color: white !important;

    svg {
      color: $gris;
    }

    &:hover {
      border-color: $neumoazul !important;

      svg {
        color: $neumoazul;
      }
    }

    &:active {
      box-shadow: none;
    }
  }
}

.llenarEncuentro {
  .btn-float {
    position: fixed;
    right: 20px;
    bottom: 20px;
    &.btn-file {
      cursor: pointer;
      i {
        color: #fff;
      }
    }
  }
}
.md-field > .md-icon {
  position: relative;
  vertical-align: bottom;
  bottom: 0;
  display: flex;
  margin-bottom: 0%;
  margin-top: 0%;
  // padding: 2.5% 0% 1% 0%;
  height: 90%;
}
.md-icon {
  margin: 0px 0px 0px 0px !important;
}
.md-field {
  margin-bottom: 0px;
  // margin-top: 10%;
  // margin: 4% 0% 0% 0%;
  font-family: "Nunito", sans-serif;
  color: #999999;
  width: 100%;
  // vertical-align: bottom;
  // bottom:0;
  // height: 95%;
}
.md-badge {
  position: relative;
}
.md-field label {
  font-size: 0.8vw;
}
#botonHistoriaMedica {
  position: absolute;
  right: 1.25vw;
  bottom: 2.222vh;
  background: white;
  z-index: 0;
  width: 72px;
  height: 72px;
}
.md-card {
  border: 1px solid #cccccc;
}
.md-field label {
  top: 15%;
}
.md-field.md-has-value label {
  top: -15% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PanelAuxiliar.vue